module.exports = __webpack_public_path__ + "img/OT134C1.0d9a53e2.png";